<app-site-settings-menu>
    <app-position-editor *ngIf="hasFeatureAccess" (formGeneratorComponentEmit)="formGeneratorComponentEmitted($event)"></app-position-editor>
    
    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-site-settings-menu>